export default __webpack_public_path__ + "static/media/NavientLogo.387d1679.png";